import FetchClient, { type ApiResponse } from "./FetchClient";

export interface DiscordWebhook {
  id: string;
  name: string;
  url: string;
  createdAt?: number;
}

export interface DiscordWebhookList {
  webhooks: DiscordWebhook[];
}

export interface DiscordWebhookInput {
  name: string;
  url: string;
}

export async function getDiscordWebhooks(): Promise<DiscordWebhookList> {
  const response = await FetchClient.get<ApiResponse<DiscordWebhookList>>("/admin/discord-webhooks");
  return response.data;
}

export async function createDiscordWebhook(data: DiscordWebhookInput): Promise<DiscordWebhook> {
  const response = await FetchClient.post<ApiResponse<DiscordWebhook>>("/admin/discord-webhooks", data);
  return response.data;
}

export async function updateDiscordWebhook(id: string, data: DiscordWebhookInput): Promise<DiscordWebhook> {
  const response = await FetchClient.patch<ApiResponse<DiscordWebhook>>(`/admin/discord-webhooks/${encodeURIComponent(id)}`, data);
  return response.data;
}

export async function deleteDiscordWebhook(id: string): Promise<void> {
  await FetchClient.delete(`/admin/discord-webhooks/${encodeURIComponent(id)}`);
}
